import * as actionTypes from '../../actions/types';
import { updateObject } from '../../../constants/utility';

const initialState = {
    isLoading: false,
    isComplete: null,
    error: null,
    data: null,
};

const relationshipsStart = (state) =>
    updateObject(state, { isLoading: true, isComplete: false, error: null });

const relationshipsSuccess = (state, action) =>
    updateObject(state, {
        isLoading: false,
        isComplete: true,
        error: null,
        data: action.data.relationships,
    });

const relationshipsFail = (state, action) =>
    updateObject(state, {
        isLoading: false,
        isComplete: null,
        error: action.error,
        data: null,
    });

const putRelationshipVisibilityStart = (state) =>
    updateObject(state, { isLoading: true, error: null });

const putRelationshipVisibilitySuccess = (state, action) => {
    const updatedData = state.data?.map((relationship) => {
        if (relationship.payee_account_id === action.payeeAccountId) {
            return updateObject(relationship, { is_hidden: action.isHidden });
        }
        return relationship;
    });

    return updateObject(state, {
        isLoading: false,
        error: null,
        data: updatedData,
    });
};

const putRelationshipVisibilityFail = (state, action) =>
    updateObject(state, {
        isLoading: false,
        error: action.error,
    });

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RELATIONSHIPS_START:
            return relationshipsStart(state);
        case actionTypes.RELATIONSHIPS_SUCCESS:
            return relationshipsSuccess(state, action);
        case actionTypes.RELATIONSHIPS_FAIL:
            return relationshipsFail(state, action);
        case actionTypes.PUT_RELATIONSHIP_VISIBILITY_START:
            return putRelationshipVisibilityStart(state);
        case actionTypes.PUT_RELATIONSHIP_VISIBILITY_SUCCESS:
            return putRelationshipVisibilitySuccess(state, action);
        case actionTypes.PUT_RELATIONSHIP_VISIBILITY_FAIL:
            return putRelationshipVisibilityFail(state, action);

        default:
            return state;
    }
};

export default reducer;
